import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

const SuccessCheck = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <circle cx="50" cy="48" r="25" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88ZM67.0628 38.5728C68.4837 36.8812 68.2643 34.3581 66.5728 32.9372C64.8812 31.5163 62.3581 31.7357 60.9372 33.4272L41.4276 56.653L41.1162 56.3228L34.9104 49.7408C33.3949 48.1334 30.8633 48.059 29.2559 49.5745C27.6486 51.09 27.5741 53.6216 29.0896 55.2289L35.2955 61.8109L37.7168 64.379L38.4309 65.1363L38.623 65.34L38.6727 65.3928L38.6854 65.4062L38.6886 65.4096L38.6894 65.4104L38.6896 65.4106L41.6 62.6667L38.6896 65.4107C39.4728 66.2413 40.5735 66.6977 41.7147 66.665C42.8558 66.6323 43.9286 66.1136 44.6628 65.2394L67.0628 38.5728Z"
      fill="#2F9E44"
    />
  </svg>
));

export default SuccessCheck;
